<template>
    <v-container class="main-header" :class="{'isCheckout': isCheckout}">
        <v-layout align-center>
            <router-link to="/">
                <img :src="require('../../assets/logo.png')" class="custom-logo" :class="{'isCheckout': isCheckout}" itemprop="logo" v-if="$vuetify.breakpoint.smAndUp && !isCheckout" />
                <img v-else :src="require('../../assets/logo-mobile.png')" class="custom-logo" />
            </router-link>
            <v-spacer></v-spacer>
                <img :src="require('../../assets/logo-microsite.png')" v-if="$vuetify.breakpoint.mdAndUp && !isCheckout" />
            <v-spacer></v-spacer>
            <div @click="drawer = true" v-if="!isCheckout">
                <v-badge
                        :content="itemsInCart"
                        :value="itemsInCart"
                        color="primary"
                        overlap
                >
                    <img class="cart-image" :src="require('../../assets/cart.png')" :class="{mobileCart: $vuetify.breakpoint.xsOnly}" />
                </v-badge>
            </div>
        </v-layout>

        <v-navigation-drawer
                temporary
                v-model="drawer"
                :right="true"
                fixed
                width="340"
        >
            <cart-overlay @drawerClose="drawer = false" />
        </v-navigation-drawer>
    </v-container>
</template>

<script>
    import {mapGetters} from 'vuex'
    import CartOverlay from '../Cart/CartOverlay'

    export default {
        name: 'MainHeader',
        props: ['isCheckout'],
        data () {
            return {
                drawer: false
            }
        },
        components: {
            CartOverlay
        },
        computed: {
            ...mapGetters([
                'cartProducts'
            ]),
            itemsInCart() {
                let cart = this.cartProducts;                
                if (!cart[0]) return null;
                return cart.reduce((accum, item) => accum + item.qty, 0)
            }
        }
    }
</script>

<style lang="scss">
    .main-header {
        .cart-image {
            cursor: pointer;
        }
        .mobileCart {
            max-width: 80px;
        }
        background-color: #000000 !important;
        &.isCheckout {
            padding-top: 0;
            padding-bottom: 0;
        }
        .menu-item {
            a {
                padding: 0 1em;
                font-size: 16px;
                color: #FFFFFF !important;
                text-decoration: none;
                text-transform: uppercase;
                &:hover {
                    opacity: 0.7;
                }
            }
        }
        .custom-logo {
            margin-top: 5px;
            max-width: 180px;
            &.isCheckout {
                max-width: 150px;
            }
        }
        .menu-icon-link {
            border-radius: 7px !important;
        }
        .v-list, .v-menu__content {
            border-radius: 0 !important;
        }
        .v-menu__content {
            max-width: 100% !important;
            width: 100%;
            left: 0 !important;
        }
        .v-chip {
            .v-chip__content {
                cursor: pointer !important;
            }
        }
        .opening-hours {
            strong {
                display: block;
                font-weight: 600;
                font-size: 14px;
            }
        }
    }
</style>
